<template>
  <div class="mb-1" :class="{ active: isActiveLink }" @click="$emit('click', $event)">
    <router-link class="block pl-2 pr-4 py-1" :to="link">
      <div class="hvh-flex align-center py-1 pr-2">
        <v-icon class="icon" color="black" small>{{ icon }}</v-icon>

        <span class="uppercase font-md bold no-wrap ml-1 mt-05">{{ text }}</span>
        <slot></slot>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['icon', 'text', 'link', 'forceActive'],
  computed: {
    isActiveLink() {
      if (this.forceActive === 'disable')
        return false;

      return this.forceActive || this.$route.name === this.link.name;
    },
  },
  methods: {
    goToLink() {
      !this.isActiveLink && this.goTo(this.link);
    },
  },
}
</script>

<style lang="scss" scoped>
.active {
  border-radius: 7px;
  background-color: rgba(133, 199, 211, 0.23);
}
</style>